import axios from "axios";
import { getToken } from "../../auth/authService";

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: { Authorization: `Bearer ${getToken()}` }
});

// Fetch all users
export const fetchAllUsers = () => api.get("/admin/users");

// Get user details
export const getUserDetails = (userId) => api.get(`/admin/users/${userId}/details`);

// Suspend / Activate
export const suspendUser = (id, reason) =>
  api.put(`/admin/users/${id}/suspend`, null, {
    params: { suspend: true, reason },
  });

export const activateUser = (userId) => api.put(`/admin/users/${userId}/activate`);

// Subscription history
export const getUserSubscriptionHistory = (userId) =>
  api.get(`/admin/users/${userId}/subscriptions`);

// Increase subscription sessions
export const increaseSubscriptionSessions = (userId, subscriptionId, additionalSessions) =>
  api.put(`/admin/users/${userId}/subscriptions/${subscriptionId}/increase-sessions`, null, {
    params: { additionalSessions }
  });
